import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import stoneforexLogo from '../../../../assets/stoneforex-logo.png';
import styles from './Header.module.css';

function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/'); // Redirect to homepage after logout
  };

  return (
    <header className={styles.header}>
      {/* Logo Section */}
      <div className={styles.logoSection}>
        <Link to="/" className={styles.logoLink}>
          <img src={stoneforexLogo} alt="StoneForex" className={styles.logo} />
        </Link>
      </div>

      {/* Navigation Links */}
      <nav className={styles.navigation}>
        <Link to="/dashboard" className={`${styles.navLink} ${styles.active}`}>
          Home
        </Link>
        <Link to="/dashboard/demo-accounts" className={styles.navLink}>
          Demo Accounts
        </Link>
        <Link to="/dashboard/markets" className={styles.navLink}>
          Markets
        </Link>
        <Link to="/dashboard/portfolio" className={styles.navLink}>
          Portfolio
        </Link>
      </nav>

      {/* ✅ ADDED: Logout Button */}
      <div className={styles.rightSpace}>
        <button onClick={handleLogout} className={styles.logoutBtn}>
          🚪 Logout
        </button>
      </div>
    </header>
  );
}

export default Header;
